import { Module } from 'vuex'
import { RootState } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { usePremiumHttp } from '@/core/api/premium'
import { PremiumPersonalizedPlan, PremiumPersonalizedPlanPayload } from '@/core/models/premium-personalized-plan'

export type PremiumPersonalizedPlanCollection = {
    data: Array<PremiumPersonalizedPlan>,
    meta?: MetaPayload,
}

const state: PremiumPersonalizedPlanCollection = {
    data: [],
    meta: <any>{},
}

export const premiumPersonalizedPlanCollection: Module<PremiumPersonalizedPlanCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: PremiumPersonalizedPlanCollection, payload: any) => {
            state.data = []
            ;(payload.data || []).forEach((item: PremiumPersonalizedPlanPayload) => {
                state.data.push(new PremiumPersonalizedPlan(item))
            })
            state.meta = payload.meta
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                usePremiumHttp()
                    .getPersonalizedPlans(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: PremiumPersonalizedPlanCollection): PremiumPersonalizedPlanCollection => {
            return state
        },
    },
}
